import { withTranslation } from '@application/i18n/with_translation';
import { Button, ButtonArrange, CellulaFormSubmitData, Flex, Form, InputText, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { useResolveController } from '@visiba/instantiation';
import { ViewAnonymousChatController } from '../view_anonymous_chat.controller';

export function ScreenTemporaryUsername() {
	const controller = useResolveController(ViewAnonymousChatController);

	function handleSubmit(data: CellulaFormSubmitData) {
		const formData = data as { chatname: string };
		controller.setDisplayName(formData.chatname);
		controller.goToScreen('initial-message');
	}

	function handleAbort() {
		controller.signOutAndRedirect();
	}

	return (
		<Form.Root onSubmit={handleSubmit} options={{ mode: 'onSubmit' }}>
			<Flex grow='1' gap={tokens.spacing.x2}>
				<Title title={withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Title')} />
				<Text variant='bodyRegular'>{withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Body')}</Text>

				<InputText
					name='chatname'
					label={withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Input.Label.Name')}
					defaultValue={controller.state.value.displayName ?? ''}
					options={{
						required: withTranslation('View.AnonymousChat.ScreenTemporaryUsername.ValidationError.Required.Name'),
						minLength: {
							value: 2,
							message: withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Input.Validation.MinLength', { minLength: '2' }),
						},
						maxLength: {
							value: 20,
							message: withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Input.Validation.MaxLength', { maxLength: '20' }),
						},
					}}
				/>
				<ButtonArrange gap={tokens.size.x1}>
					<Form.SubmitButton variant='primary' size='large'>
						{withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Button.Continue')}
					</Form.SubmitButton>
					<Button variant='secondary' onClick={handleAbort}>
						{withTranslation('View.AnonymousChat.ScreenTemporaryUsername.Button.Cancel')}
					</Button>
				</ButtonArrange>
			</Flex>
		</Form.Root>
	);
}
